import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { TicketsPage } from "@/features/tickets/TicketsPage";

const search = z.object({
  queue: z.enum(["all", "mine", "not-replied"]).optional(),
});

export const Route = createFileRoute("/_app/tickets/$ticket")({
  validateSearch: search,
  component: Page,
});

function Page() {
  const { ticket } = Route.useParams();
  return <TicketsPage search={Route.useSearch()} ticketId={ticket} />;
}
